'use strict';
import React, { PureComponent } from 'react';
import Header from './Header.jsx';
import Titulo from './Titulo.jsx';
import SubHeader from './SubHeader.jsx';
import SaldosResumenesLimites from './SaldosResumenesLimites/SaldosResumenesLimites.jsx';
import CuentaCorriente from './CuentaCorriente.jsx';
import Dialog from 'rc-dialog';
import TotalCuotasPendientes from './CuentaCorriente/TotalCuotasPendientes/TotalCuotasPendientes.jsx';

class SaldosResumenes extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            esCuentaCorriente: false,
            currentAccuntId: this.props.data.idEntidad
        }
        this.cambiarOpcionResumen = this.cambiarOpcionResumen.bind(this);

    }

    /**
     * 
     * @param {any} valor
     */
    cambiarOpcionResumen(valor) {
        this.setState({ esCuentaCorriente: valor });
    }

    componentDidMount() {
        /*el id que cambia es el idEntidad de panel seleccion*/
        this.props.getScreenData(this.props.vistaCliente.userFeatures, this.props.data.idEntidad);
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.currentAccuntId != nextProps.data.idEntidad) {
            this.setState({ currentAccuntId: nextProps.data.idEntidad, esCuentaCorriente: false });
            this.props.getScreenData(this.props.vistaCliente.userFeatures, nextProps.data.idEntidad);
        }
    }

    componentWillUnmount() {
        this.props.resetState();
    }

    validarTotal(totalCuotasPendientes) {
        if (!totalCuotasPendientes) {
            return false;
        }
        return totalCuotasPendientes.TotalPendtConsumo > 0;
    }

    render() {
        const { data, getCuentaCorrienteData, getCuotasPendientes, toggleTotalCuotasPendientes, saldosResumenes, mostrarComponente, mostrarModal } = this.props;
        const { cuenta, fechasCierres, ultimoCierre, limiteDisponible, isLoading, cuentaCorriente, modalTotalCuotasPendientes } = saldosResumenes;
        const { vistaCliente } = data;

        let componente = <div className="loading">Loading &#8230;</div>;

        if (isLoading == false) {

            let cuotasPendientesTotales = cuentaCorriente ? cuentaCorriente.cuotasPendientesTotales : [];
            let cuotasPendientes = cuentaCorriente ? cuentaCorriente.cuotasPendientes : [];
            let cuotasPendientesDolares = cuentaCorriente ? cuentaCorriente.cuotasPendientesDolares : [];
            let cuotasPendientesPesos = cuentaCorriente ? cuentaCorriente.cuotasPendientesPesos : [];
            let totalCuotasPendientesDolares = cuentaCorriente ? cuentaCorriente.totalCuotasPendientesDolares : [];
            let totalCuotasPendientesPesos = cuentaCorriente ? cuentaCorriente.totalCuotasPendientesPesos : [];
            let fechasCierresConsumos = cuentaCorriente ? cuentaCorriente.fechasCierresConsumos : [];
            let tarjetasCreditoId = cuentaCorriente ? cuentaCorriente.tarjetasCreditoId : [];
            let extensiones = cuentaCorriente ? cuentaCorriente.extensiones : [];

            componente = <div>
                <Header cuentaDenominacion={cuenta.CuentaDenominacion} cuentaDescripcion={cuenta.Descripcion} vistaCliente={vistaCliente} />
                <Titulo cuentaTarjetaNumero={cuenta.CuentaTarjetaNumero} tipoCuenta={cuenta.TipoCuenta} fechasCierres={fechasCierres} />
                <SubHeader
                    saldosResumenes={saldosResumenes}
                    cambiarOpcionResumen={this.cambiarOpcionResumen}
                    esCuentaCorriente={this.state.esCuentaCorriente}
                    limiteDisponible={limiteDisponible}
                />
                {this.state.esCuentaCorriente ?
                    <div>
                        <CuentaCorriente
                            toggleTotalCuotasPendientes={toggleTotalCuotasPendientes}
                            getCuentaCorrienteData={getCuentaCorrienteData}
                            getCuotasPendientes={getCuotasPendientes}
                            cuentaTarjetaId={cuenta.Id}
                            saldosResumenes={saldosResumenes}
                        />
                        <Dialog
                            visible={modalTotalCuotasPendientes}
                            onClose={() => this.props.toggleTotalCuotasPendientes()}
                            animation="slide-fade"
                            maskAnimation="fade"
                            style={{
                                width: 892,
                                height: 502
                            }}
                            title="Detalle de Cuotas Pendientes"
                            footer={[
                                <button
                                    type="button"
                                    className="btn btn-default"
                                    key="close"
                                    onClick={() => this.props.toggleTotalCuotasPendientes()}
                                >
                                    Cerrar
                    </button>
                            ]}
                        >
                            {(this.validarTotal(totalCuotasPendientesPesos) || this.validarTotal(totalCuotasPendientesDolares)) ?
                                <TotalCuotasPendientes extensiones={extensiones}
                                    cuotasPendientesDolares={cuotasPendientesDolares}
                                    cuotasPendientesPesos={cuotasPendientesPesos}
                                    totalCuotasPendientesDolares={totalCuotasPendientesDolares}
                                    totalCuotasPendientesPesos={totalCuotasPendientesPesos}
                                    fechasCierresConsumos={fechasCierresConsumos}
                                    tarjetasCreditoId={tarjetasCreditoId} /> :
                                <label>No existen cuotas pendientes de devengamiento al cierre consultado</label>
                            }
                        </Dialog>
                    </div> :
                    <SaldosResumenesLimites saldosResumenes={saldosResumenes} />
                }
            </div>
        }

        return (
            <div className="tarjetas saldos-resumenes">
                <div className="container-fluid saldos-resumenes">
                    {componente}
                </div>
            </div>
        );
    }
}

export default SaldosResumenes;